import React from "react";
import { Link, LinkProps } from "react-router-dom";

/**
 * MUI's LinkBehavior adapter: takes the `href` a package component passes and
 * routes it client-side. Pass it as a package `Card` link action's `component`.
 */
const RouterLinkBehavior = React.forwardRef<
  HTMLAnchorElement,
  Omit<LinkProps, "to"> & { href: string }
>(({ href, ...rest }, ref) => <Link ref={ref} to={href} {...rest} />);

RouterLinkBehavior.displayName = "RouterLinkBehavior";

export default RouterLinkBehavior;
